<!--<h1 mat-dialog-title>PEP questions</h1>-->
<!--<hr>-->
<!--<div mat-dialog-content>-->
<!--    <div class="row d-flex align-items-center">-->
<!--        <div class="col"><span>What's your favorite animal?</span></div>-->
<!--        <div class="col-auto">-->
<!--            <app-radio-group></app-radio-group>-->
<!--        </div>-->
<!--    </div>-->
<!--    <hr>-->
<!--    <div class="row d-flex align-items-center">-->
<!--        <div class="col"><span>Nam sit amet odio consectetur, euismod mi sed, ultrices est. Proin urna tortor, aliquam ut magna quis, scelerisque tincidunt neque. Maecenas faucibus vulputate neque, sed rhoncus sem suscipit sit amet</span>-->
<!--        </div>-->
<!--        <div class="col-auto">-->
<!--            <app-radio-group></app-radio-group>-->
<!--        </div>-->
<!--    </div>-->
<!--    <hr>-->
<!--    <div class="row d-flex align-items-center">-->
<!--        <div class="col"><span>Duis a velit efficitur, luctus libero a, auctor diam. Donec ullamcorper lacinia lectus a condimentum.</span>-->
<!--        </div>-->
<!--        <div class="col-auto">-->
<!--            <app-radio-group></app-radio-group>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
<!--<div class="text-center mt-3">-->
<!--    <button class="btn btn-sm btn-primary mr-3" type="submit">Save</button>-->
<!--    <a href="javascript:void('0');" id="cancel">Cancel</a>-->
<!--</div>-->

<h1 mat-dialog-title><i class="fa fa-file-text-o mr-2"></i>Add Document</h1>
<div mat-dialog-content class="mx-0">
    <app-panel-input></app-panel-input>
    <app-select></app-select>
    <app-autocomplete></app-autocomplete>
    <app-datepicker></app-datepicker>
    <div class="file-upload-area">
        <button type="button" (click)="imgFileInput.click()" class="btn btn-default w-100">
            <span><i aria-hidden="true" class="fa fa-upload"></i></span>
            No File Chosen
            <div hidden class="file-info align-middle">fdfdsfsd.png</div>
        </button>
        <input hidden type="file" #imgFileInput/>
    </div>
    <a id="showAdvanceOptions" class="mt-2 d-inline-block" href="javascript:void(0);">More Options</a>

</div>
<div mat-dialog-actions class="justify-content-end px-4 mt-2">
    <button class="btn btn-primary mr-3" type="submit">Add</button>
    <button class="btn btn-outline-secondary">Cancel</button>
</div>
